<template>
  <div class="row bg-secondary-subtle mb-2 fw-bold d-none d-lg-flex p-1 g-0">
    <div class="col-4 p-1">
      <p class="mb-0">{{ $t("requestInvoice.item") }}</p>
    </div>
    <div class="col-2 p-1 text-end">
      <p class="mb-0">{{ $t("requestInvoice.quantity") }}</p>
    </div>
    <div class="col-2 p-1 text-end">
      <p class="mb-0">{{ $t("requestInvoice.unit_price") }}</p>
    </div>
    <div class="col-2 p-1 text-end">
      <p class="mb-0">{{ $t("requestInvoice.total_excl_vat") }}</p>
    </div>
    <div class="col-2 p-1 text-end">
      <p class="mb-0">{{ $t("requestInvoice.vat") }}</p>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
